export function setgPayDates(setValues, values, groupPayDates, setGroupData, setPayDateData, setFieldValue, t) {
  setValues({ ...values, ...groupPayDates });
  if ((groupPayDates?.groupPayDates || []).length > 0) {
    setGroupData((groupPayDates?.groupPayDates || []).map((groupData) => groupData.groupName));
  }

  if (
    (groupPayDates?.unlinkedPayDates || []).length > 0 &&
    ((groupPayDates?.groupPayDates || []).length === 0 || values?.group === undefined)
  ) {
    const { unlinkedPayDates = [] } = groupPayDates;
    setPayDateData(unlinkedPayDates);
  }

  if (
    (groupPayDates?.unlinkedPayDates || []).length === 0 &&
    (groupPayDates?.groupPayDates || []).length === 1 &&
    values?.group === undefined
  ) {
    const firstGroup = groupPayDates.groupPayDates && groupPayDates.groupPayDates[0];
    if (firstGroup) {
      setFieldValue("group", firstGroup?.groupName || "");
      const firstPayDate = firstGroup.payDates && firstGroup.payDates[0];
      if (firstPayDate) {
        setFieldValue("payDate", firstPayDate);
      }
    }
  }
  if ((groupPayDates?.unlinkedPayDates || []).length === 1 && values?.payDate === undefined) {
    setFieldValue("group", t("employeeCreation.single.noGroup"));
    setFieldValue("payDate", groupPayDates?.unlinkedPayDates[0]);
  }
}

export function setValueGroups(groupPayDates, values, setPayDateData, setFieldValue) {
  const selectedGroupPayDate = (groupPayDates?.groupPayDates || []).filter(
    (group) => group?.groupName === values?.group,
  );
  const selectedPayDate = selectedGroupPayDate[0]?.payDates || [];
  if (selectedPayDate.length > 0) {
    setPayDateData(selectedPayDate);
  }
  if (selectedPayDate.length === 1) {
    setFieldValue("payDate", selectedPayDate[0]);
  } else if (values?.payDate && selectedPayDate.includes(values?.payDate)) {
    setFieldValue("payDate", values?.payDate);
  }
}
